import { React, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
// import { HiOutlineSearch } from "react-icons/hi";
import * as api from 'API/api';

const AppointmentsLayout = () => {

  const [bookingData, setBookingData] = useState({

    selectedServices: [], // array of serviceIds


    selectedDate: "",     // "YYYY-MM-DD"
    selectedTime: "",     // "9:00 AM" (or "09:00")


    customer: {
      fullName: "",
      phone: "",
      email: "",
    },


    vehicle: {
      make: "",
      model: "",
      year: "",
      plate: "",
      odo: "",
    },
  });

  const [serviceData, setServiceData] = useState([]);
  useEffect(() => {
    const loadServices = async () => {
      const services = await api.fetchServices();
      setServiceData(services);
      console.log(services);
    }
    loadServices();
  }, []);

  return (
    <main className="bg-gray-50">
      <section className="mx-auto max-w-4xl px-4 py-10">
        <h1 className="text-3xl font-bold text-gray-900">
          Book an Appointment
        </h1>

        <div className="mt-2 flex flex-wrap items-center gap-3">
          <p className="text-gray-600">
            Follow the steps below to schedule your service 
          </p>



          {/* <Link
            to="/check"
            className="inline-flex items-center gap-2 rounded-xl bg-blue-600 px-5 py-2 text-sm font-semibold text-white hover:bg-blue-500"
          >
            <HiOutlineSearch className="h-4 w-4" />
            Check your appointment
          </Link> */}
        </div>

        <div className="mt-8">
          <Outlet context={{ bookingData, setBookingData, serviceData }} />
        </div>

        <div className="h-12" />
      </section>
    </main>
  );
};

export default AppointmentsLayout;
